import React from 'react';
import { Spinner } from 'src/components/animations/Spinner';
import PreloadIcon from '../../images/loader.svg?url';

interface Props {
  className?: string;
  throbber?: boolean;
  size?: number;
}

/**
 * Компонент для отображения прелоадера
 * если передан `throbber`, отображается спиннер
 * или выводится анимированный лоадер ЛТ
 */
export const Preloader = ({ className = '', throbber, size = 80 }: Props) => {
  if (throbber) {
    return <Spinner size={size} className={className} />;
  }

  return (
    <img
      className={className}
      src={PreloadIcon}
      alt=""
      height={size}
      width={size}
    />
  );
};
